import { StrictMode, useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppAiAssistServer } from "./imago-app/server_pages/appAiAssist";
import { useAtom } from "jotai";
import { langCodeAtom } from "./imago-app";
import { defaultLang, languages, setLanguage } from "./i18n";

const Router = () => {
  const [langCode, setLangCode] = useAtom(langCodeAtom);
  const [currentLangCode, setCurrentLangCode] = useState("");

  useEffect(() => {
    const updateLang = async () => {
      await setLanguage(currentLang);
      await setCurrentLangCode(currentLang.code);
    };
    const currentLang = languages.find((lang) => lang.code === langCode) || defaultLang;
    updateLang();
  }, [langCode]);

  return (
    <StrictMode>
      <BrowserRouter>
        <Routes>
          <Route
            path="/index"
            element={<AppAiAssistServer currLangCode={currentLangCode} />}
          ></Route>
          <Route
            path="/agent"
            element={<AppAiAssistServer currLangCode={currentLangCode} />}
          ></Route>
        </Routes>
      </BrowserRouter>
    </StrictMode>
  );
};

export default Router;